import { observable, action, runInAction, toJS } from "mobx";
import { weappSDK } from '@weapp/utils';
import { MDialog } from '@weapp/ui';
import * as API from "../../api/login";
import { LangItem } from "../../components/m/i18n/type";
import { clearCookieByName, getCookie, getQueryString, inApp, setCookie } from "../../utils";
import { pcSkinStore } from "../../store/pc";
import { publicUrl } from "../../constants";
const { toast } = MDialog
const INIT_LANGS = () => ({
  otherLangs: [],
  defaultLangs: []
})

export class I18nStore {
  @observable defaultLangs: any = [];
  @observable otherLangs: any = [];
  @observable currentLang: string = "";
  @observable langs: any = INIT_LANGS()
  @observable currentLangInfo: any = {};//当前语言信息，pc使用

  // @action
  // init = () => {
  //   this.getCurrentLang();
  //   //获取APP语言选项


  // }

  @action
  reset = () => {
    this.langs = INIT_LANGS();
    this.otherLangs = [];
    this.defaultLangs = [];
    this.currentLang = '';
    //app获取

  }
  @action
  getCurrentLang = () => {
    let currentLang = getCookie("langType");
    console.log("currentLang：" + currentLang);
    if (!currentLang) {
      currentLang = "zh_CN";
    }
    this.currentLang = currentLang;
  };
  @action
  setCurrentLang = (lang: string) => {
    this.currentLang = lang;
  }

  @action
  getLangs = (type?: any) => {
    this.getCurrentLang();
    API.getLangs()
      .then((result: any) => {
        runInAction(() => {
          if (result && result.data) {
            this.langs = {
              otherLangs: [],
              defaultLangs: []
            }
            result.data.forEach((lang: LangItem) => {
              if (lang.langtype === this.currentLang) {
                lang.isCurrent = true;
                this.currentLangInfo = lang;
              }
              if (lang.isdefault) {
                this.langs.defaultLangs.push(lang);
              } else {
                this.langs.otherLangs.push(lang);
              }
            });
          }
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  @action
  updateLang = (langtype: string) => {
    for (let x in this.langs) {
      this.langs[x].forEach((lang: LangItem) => {
        lang.isCurrent = false;
        if (langtype === lang.langtype) {
          lang.isCurrent = true;
        }
      });
    }
    this.langs = { ...this.langs };
    this.currentLang = langtype;
  };

  //h5
  @action
  saveLang = (isEbBindPage = false) => {
    let olddomain = '.' + window.location.hostname.split('.').slice(-2).join('.');
    const isCustomPage = !!getQueryString("wea_link_keep_customlogin");
    const customloginPage = '/customlogin/' + getQueryString("wea_link_keep_customlogin");
    const redirectPath = isEbBindPage ? `${publicUrl}/passport/ebBind` : `${publicUrl}${isCustomPage ? customloginPage : "/login"}`
    //清理之前的错误cookie，上线一段时间之后删除
    clearCookieByName('langType');
    document.cookie = "langType=;domain=" + olddomain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    let domain = window.location.hostname;
    if (domain.indexOf('passport') !== -1) {
      domain = domain.replace('passport', '');
    }
    setCookie("langType", this.currentLang, domain);
    if (inApp()) {
      try {
        weappSDK.customSDK.invoke("setItem", {
          key: 'langType',
          value: this.currentLang,
          success: (res: any) => {
            toast({
              content: JSON.stringify(res),
              delay: 0
            })
            window.location.href = redirectPath;
          }
        })
      } catch (e: any) {
        window.location.href = redirectPath;
      }
    } else {
      window.location.href = redirectPath;
    }
  };

  @action
  updatePCLang = (langtype: any) => {
    let olddomain = '.' + window.location.hostname.split('.').slice(-2).join('.');
    clearCookieByName('langType');
    //清理之前的错误cookie，上线一段时间之后删除
    document.cookie = "langType=;domain=" + olddomain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    let domain = window.location.hostname;
    if (domain.indexOf('passport') !== -1) {
      domain = domain.replace('passport', '');
    }
    setCookie("langType", langtype, domain);
    // if (pcSkinStore.customPagePath) {
    //   window.location.href = `${publicUrl}${pcSkinStore.customPagePath}`;
    // } else {
    //   window.location.href = window.location.pathname.indexOf('adminlogin') !== -1 ? `${publicUrl}/adminlogin` : `${publicUrl}/`;
    // }
    window.location.reload()
  }

}

const instance = new I18nStore();
export type I18nStoreType = Pick<I18nStore, keyof I18nStore>;
export default instance;
